import { useEffect } from "react";

const UserWayWidget = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.setAttribute("data-account", "c9Zpvxbvft");
        script.src = "https://cdn.userway.org/widget.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script); // Cleanup on unmount
        };
    }, []);

    return null; // This component doesn't render anything visually
};

export default UserWayWidget;
